export const config = {
  apiKey: "AIzaSyCx-cQpci9dh3xuRgw_J9whfjjaL8K4lKA",
  authDomain: "lefevre-expertise-comptable.firebaseapp.com",
  databaseURL: "https://lefevre-expertise-comptable.firebaseio.com",
  projectId: "lefevre-expertise-comptable",
  storageBucket: "lefevre-expertise-comptable.appspot.com",
  messagingSenderId: "164613043220",
  appId: "1:164613043220:web:64940f18a28ddf99c06301"
};
